<template>
  <div
    class="split-button flex-center"
    ref="buttonSplit"
    :class="[hasBorderParent ? dbOptionHeight + '-border' + ' border-split-btn' : dbOptionHeight]"
  >
    <button
      ref="resize"
      class="btn flex-row primary-button"
      :class="[type, classCustom, hasBorder ? dbOptionHeight + '-border' : dbOptionHeight + ' btn-border-none']"
      :disabled="disabled"
      @click="$emit('primaryClick', $event)"
    >
      <div :class="['icon24 icon left', leftIcon]" v-if="leftIcon">&nbsp;</div>
      <div class="text" :class="[{ 'pl-0': leftIcon }]" v-if="text">
        {{ text }}
      </div>
    </button>
    <div class="button-line"></div>
    <menu-wrapper class="widget-more-container widget-btn" :class="[type, hasBorder ? dbOptionHeight + '-border' : dbOptionHeight + ' btn-border-none']" :disabled="disabled" ref="wrapper">
      <template #menu-button="{ toggleMenu }">
        <button
          @click.prevent="toggleMenu"
          :class="[
            type,
            classCustom,
            hasBorder ? dbOptionHeight + '-border' : dbOptionHeight + ' btn-border-none',
            heightOption == 2 ? rightIcon ? rightIcon :'widget-more' : hasBorder ? 'widget-more-small-border' : 'widget-more-small',
          ]"
          :disabled="disabled"
        ></button>
      </template>
      <template #menu-content>
        <menu-item
          v-for="(item, index) in menuItems"
          :key="index"
          :seperatorBottom="item.seperatorBottom"
          :visible="item.visible"
          @menu-item-click="clickItem(item)"
          >{{ item.text }}</menu-item
        >
      </template>
    </menu-wrapper>
  </div>
</template>
<script>
import { defineComponent, computed, ref, getCurrentInstance } from 'vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import ScrollParent from '@/commons/componentMixin';

export default defineComponent({
  name: 'msSplitButton',
  components: {
    MenuWrapper,
    MenuItem,
  },
  props: {
    //Text hiển thị
    text: {
      defualt: null,
      type: String,
    },
    //Icon trái
    leftIcon: {
      default: null,
      type: String,
    },
    //Icon phải
    rightIcon: {
      default: null,
      type: String,
    },
    //Loại button gồm 3 loại primary/secondary/third/four để hiện thị style tương ứng
    type: {
      default: 'primary',
      type: String,
    },
    /**
     * Trạng thái button disabled
     */
    disabled: {
      default: false,
      type: Boolean,
    },
    /**
     * Danh sách các item của context menu
     */
    menuItems: {
      type: Array,
      default: new Array(),
    },
    /**
     * ĐVThi 18/02/2020
     * muốn đặt thêm stype cho lớp mục đích có cách để trên form tìm được đến control
     */
    classCustom: {
      default: '',
      type: String,
    },
    /**
     * NNLAM 26/02/2020
     * có cho phép tự custom vị trí dropdown menu hay không
     */
    customPositionMenu: {
      type: Boolean,
      default: false,
    },
    /**
     * NNLAM 26/02/2020
     * Set lại chiều dài menu dropdown
     */
    customWidth: {
      type: Number,
      default: 0,
    },
    /**
     * NNLAM 26/02/2020
     * khoảng cách của button so với lề trên/dưới
     */
    heightOffset: {
      type: Number,
      default: 5, //25
    },
    /**
     * NNLAM 26/02/2021
     * khoảng cách của button so với lề trái/phải
     */
    widthOffset: {
      type: Number,
      default: 25,
    },
    /**
     * NNLAM 26/02/2021
     * Có show menu khi click vào icon right của button không, mặc định có
     */
    hasShowMenu: {
      type: Boolean,
      default: true,
    },
    /**
     * NNLAM 26/02/2021
     * Có tooltip cho btt không
     */
    tooltipText: {
      type: [String, Object],
      default: null,
    },
    //border hiển thị cho các button con
    hasBorder: {
      default: false,
      type: Boolean,
    },
    //border bên ngoài 2 button con
    hasBorderParent: {
      default: false,
      type: Boolean,
    },
    //không phụ thuộc vào giá trị height trong db_option
    ignoreDbOptionHeight: {
      default: false,
      type: Boolean,
    }
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();

    const clickItem = item => {
      emit('menuClick', item);
    };

    ScrollParent();

    function processScrollParent() {
      proxy.$refs.wrapper.closeHandler();
    }

    const toggleMenu = ref(false);

    const dbOptionHeight = computed(() => {
      if(props.ignoreDbOptionHeight)
      {
        return 'heightoptionvalue2';
      }
      return 'heightoptionvalue' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });

    const heightOption = computed(() => {
       if(props.ignoreDbOptionHeight)
      {
        return 2;
      }
      return proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2;
    });
    // end -----------------------------------------------------------------------

    return {
      clickItem,
      toggleMenu,
      processScrollParent,
      dbOptionHeight,
      heightOption,
    };
  },
});
</script>

<style scoped lang="scss">
@import '@/assets/scss/components/MsButton.scss';

.split-icon {
  width: 36px;
  height: 24px;
  margin: 0 !important;
  .icon {
    margin: 0;
    cursor: pointer;
  }
}

.context-item {
  height: 36px;
  padding: 2px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  .context-text {
    padding: 0 8px;
  }
  &:hover {
    cursor: pointer;
    background: $hover-bg;
    color: #14aa8a;
  }
}
.context-icon {
  margin-right: 8px;
}
.color-red {
  color: #ff0000;
}
.button-line {
  display: inline-block;
  width: 1px;
  height: 16px;
  background-color: #fff;
}
.split-button {
  background-color: $primary;
  &.border-split-btn {
    border: 1px solid #afafaf;
    border-radius: 3px;
  }
  button {
    &.primary-button {
      border-end-end-radius: unset;
      border-start-end-radius: unset;
    }
  }
}
.menu-button-container {
  .heightoptionvalue1-border {
    height: $input-height-custom-small !important;
  }
  .heightoptionvalue1 {
    height: $input-height-custom-small-no-border !important;
  }
  .heightoptionvalue2-border {
    height: $input-height-custom-big !important;
  }
  .heightoptionvalue2 {
    height: $input-height-custom-big-no-border !important;
  }
  .widget-more-small-border {
    height: $input-height-custom-small;
    width: $input-height-custom-small;
    position: relative;
    border: none;
    background: none;
    outline: none;
    padding: 0;
    margin-left: 4px;

    &:hover {
      cursor: pointer;
    }

    &::before {
      content: '';
      position: absolute;
      height: $input-height-custom-small;
      width: $input-height-custom-small;
      top: 0;
      left: 0;
      background: transparent url($ms-image-sprites) no-repeat -195px -71px;
    }
  }

  .widget-more-small {
    height: $input-height-custom-small-no-border;
    width: $input-height-custom-small-no-border;
    position: relative;
    border: none;
    background: none;
    outline: none;
    padding: 0;
    margin-left: 4px;

    &:hover {
      cursor: pointer;
    }

    &::before {
      content: '';
      position: absolute;
      height: $input-height-custom-small-no-border;
      width: $input-height-custom-small-no-border;
      top: 0;
      left: 0;
      background: transparent url($ms-image-sprites) no-repeat -195px -71px;
    }
  }
}
</style>
